import { Stack, styled } from '@mui/material'
import { tokens } from 'ComponentLibrary'

export const OrderFilterContainer = styled(Stack)`
    height: 39px;
    width: 250px;
    min-width: 100px;
    flex: 1;
    flex-wrap: wrap;
    align-self: stretch;
    & .MuiAutocomplete-popper {
        margin-top: ${tokens.SizingSpacing050};
    }
`
